// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/userHome/applications/warningInfo/warningInfo.component.less
// module id = 340
// module chunks = 0